// ── Strip newsletter success params (fallback for non-AJAX submits) ───
// If the AJAX handler below fails and the form submits normally, Shopify
// redirects to ?customer_posted=true#ContactFooter. history.replaceState
// cleans the URL so a reload hits the plain path (no stale success state).
// scrollTo is intentionally omitted — the AJAX path avoids any redirect/jump.
(function() {
  if (
    window.location.search.indexOf('customer_posted') !== -1 ||
    window.location.hash === '#ContactFooter'
  ) {
    history.replaceState(null, '', window.location.pathname);
  }
})();

$(document).ready(function() {
  const $lightboxModal = $('#customLightboxModal');
  const $lightboxOverlay = $('.custom-lightbox-overlay');
  const $lightboxCloseButton = $('.custom-lightbox-close-button');
  const $lightboxImg = $('.custom-lightbox-img');
  const $lightboxTitle = $('#customLightboxTitle');
  const $lightboxDescription = $('#customLightboxDescription');
  const $lightboxCreditContainer = $('.custom-lightbox-credit-container');
  const $lightboxCredit = $('.custom-lightbox-credit');
  const $prevButton = $('.custom-lightbox-prev');
  const $nextButton = $('.custom-lightbox-next');
  const $lightboxTextContent = $('.custom-lightbox-text-content');
  
  const $imageContainer = $('.custom-lightbox-image-container');
  const $card = $('.custom-lightbox-content');

  const MIN_CARD_WIDTH = 450;
  const ABOUT_US_RADIUS = '16px';

  let galleryItems = [];
  let currentIndex = 0;
  let $lastFocusedElement = null;
  let isLoadingImage = false;

  // ── About Us radius helpers ──────────────────────────────────────────
  function applyAboutUsRadius() {
    const clipVal = 'inset(0 round ' + ABOUT_US_RADIUS + ')';
    $imageContainer[0].style.setProperty('border-radius', ABOUT_US_RADIUS, 'important');
    $imageContainer[0].style.setProperty('overflow', 'hidden', 'important');
    $imageContainer[0].style.setProperty('clip-path', clipVal, 'important');
    $lightboxImg[0].style.setProperty('border-radius', ABOUT_US_RADIUS, 'important');
    $lightboxImg[0].style.setProperty('clip-path', clipVal, 'important');
  }

  function clearAboutUsRadius() {
    $imageContainer[0].style.removeProperty('border-radius');
    $imageContainer[0].style.removeProperty('overflow');
    $imageContainer[0].style.removeProperty('clip-path');
    $imageContainer[0].style.removeProperty('width');
    $imageContainer[0].style.removeProperty('height');
    $imageContainer[0].style.removeProperty('flex');
    $lightboxImg[0].style.removeProperty('border-radius');
    $lightboxImg[0].style.removeProperty('clip-path');
  }

  // ── Lock the caption box to the tallest caption in this gallery ───────
  // Mobile portrait sizes the card to its content (see custom-new-lightbox.css),
  // so without this, flipping from a photo with a short caption to one with a
  // long caption visibly resizes the whole card. Measuring every item's
  // caption once (off-screen) and locking the box to the max height keeps the
  // card a constant size no matter which photo is showing — shorter captions
  // just leave quiet space below them instead of the card jumping.
  // Desktop already uses a fixed 155px box, and landscape stretches the
  // caption to match the image height, so neither needs this.
  function measureMaxTextContentHeight() {
    if (galleryItems.length === 0) return 0;
    if (!window.matchMedia('(max-width: 767px) and (orientation: portrait)').matches) {
      return 0;
    }

    let $probe = $('#customLightboxTextProbe');
    if ($probe.length === 0) {
      $probe = $lightboxTextContent.clone().attr('id', 'customLightboxTextProbe').removeAttr('style');
      $probe.css({
        position: 'absolute',
        visibility: 'hidden',
        pointerEvents: 'none',
        top: '-9999px',
        left: '-9999px',
        height: 'auto'
      });
      $('body').append($probe);
    }

    const measureWidth = $lightboxTextContent.width() || $card.width();
    if (!measureWidth) return 0;
    $probe.width(measureWidth);

    const $probeTitle = $probe.find('.custom-lightbox-title');
    const $probeDescription = $probe.find('.custom-lightbox-description');
    const $probeCreditContainer = $probe.find('.custom-lightbox-credit-container');
    const $probeCredit = $probe.find('.custom-lightbox-credit');

    let max = 0;
    galleryItems.forEach(function (item) {
      $probeTitle.text(item.title);
      $probeDescription.text(item.description);
      if (item.credit && item.credit.trim() !== '') {
        $probeCredit.text(item.credit);
        $probeCreditContainer.show();
      } else {
        $probeCredit.text('');
        $probeCreditContainer.hide();
      }
      const h = $probe.outerHeight();
      if (h > max) max = h;
    });

    return max;
  }

  function applyMaxTextContentHeight() {
    if ($lightboxModal.hasClass('about-us-gallery-active')) {
      $lightboxTextContent[0].style.removeProperty('height');
      return;
    }
    const h = measureMaxTextContentHeight();
    if (h > 0) {
      $lightboxTextContent[0].style.setProperty('height', h + 'px', 'important');
    } else {
      $lightboxTextContent[0].style.removeProperty('height');
    }
  }

  let textHeightResizeTimer = null;
  $(window).on('resize orientationchange', function () {
    clearTimeout(textHeightResizeTimer);
    textHeightResizeTimer = setTimeout(function () {
      if ($lightboxModal.hasClass('is-visible')) {
        applyMaxTextContentHeight();
      }
    }, 150);
  });

  function initializeGalleryItems() {
    galleryItems = [];
    $('.popup-gallery a').each(function() { 
      galleryItems.push({
        src: $(this).attr('href'),
        title: $(this).data('title') || $(this).attr('title') || '',
        description: $(this).data('description') || '',
        credit: $(this).data('credit') || '',
        element: $(this)
      });
    });
  }

  function openLightbox(index) {
    if (isLoadingImage && $lightboxModal.hasClass('is-visible')) {
      return;
    }
    isLoadingImage = true;

    if ($lightboxModal.hasClass('is-visible')) {
      if ($lightboxModal.hasClass('about-us-gallery-active')) {
        $lightboxImg.stop(true, true).css('opacity', '0');
        if (window.innerWidth <= 767) {
          $imageContainer[0].style.removeProperty('flex');
          $imageContainer[0].style.removeProperty('width');
          $imageContainer[0].style.removeProperty('height');
        }
      } else {
        const currentWidth = $imageContainer.width();
        const currentHeight = $imageContainer.height();
        $imageContainer.css({
          'width': currentWidth + 'px',
          'height': currentHeight + 'px',
          'flex': 'none'
        });
      }
    }

    $imageContainer.addClass('is-loading'); 
    
    const wasAlreadyOpen = $lightboxModal.hasClass('is-visible');
    currentIndex = index;
    const item = galleryItems[currentIndex];

    if (!wasAlreadyOpen) { 
      $lightboxModal.addClass('is-visible').attr('aria-hidden', 'false');
      $lightboxOverlay.css({
          'display': 'block', 'position': 'fixed', 'top': '0px', 'left': '0px',
          'width': '100vw', 'height': '100vh',
          'background-color': 'rgba(18, 18, 18, 0.6)',
          'opacity': '1', 'z-index': '10000' 
      }).show(); 
      disableBodyScroll();
      setTimeout(() => { $lightboxModal.focus(); }, 0); 
    }

    updateTextAndControls(item); 

    const onTempImageLoad = function() {
      $imageContainer.removeClass('is-loading');
      
      $lightboxImg.stop(true, true).css({ 'display': 'none', 'opacity': '0' });
      $lightboxImg.attr('src', this.src).attr('alt', item.title || 'Gallery image');
      
      if (!$lightboxModal.hasClass('about-us-gallery-active')) {
        $imageContainer.css({ 'width': '', 'height': '', 'flex': '' });
      }

      if (this.naturalWidth && this.naturalHeight) {
        const naturalRatio = this.naturalWidth / this.naturalHeight;

        let availableHeight;
        if ($lightboxModal.hasClass('about-us-gallery-active')) {
          availableHeight = $card.height()
            - $card.find('.custom-lightbox-header').outerHeight()
            - 40;
        } else {
          availableHeight = $imageContainer.height();
        }

        const idealWidth = Math.round(availableHeight * naturalRatio);
        const maxContainerWidth = $imageContainer.parent().width() - 80;
        const finalWidth = Math.min(idealWidth, maxContainerWidth);
        const finalHeight = Math.round(finalWidth / naturalRatio);

        if ($lightboxModal.hasClass('about-us-gallery-active') && window.innerWidth > 767) {
          $imageContainer[0].style.setProperty('flex', '0 0 ' + finalWidth + 'px', 'important');
          $imageContainer[0].style.setProperty('width', finalWidth + 'px', 'important');
          $imageContainer[0].style.setProperty('height', finalHeight + 'px', 'important');
        } else if (!$lightboxModal.hasClass('about-us-gallery-active')) {
          $imageContainer.css({ 'flex': '0 0 auto', 'width': finalWidth + 'px' });
        }

        const rawCardWidth = finalWidth + 80;
        const clampedCardWidth = Math.min(
          Math.max(rawCardWidth, MIN_CARD_WIDTH),
          window.innerWidth * 0.92
        );
        $card.css('width', clampedCardWidth + 'px');
      }

      if ($lightboxModal.hasClass('about-us-gallery-active') && window.innerWidth > 767) {
        requestAnimationFrame(applyAboutUsRadius);
      }

      $lightboxImg.css('display', 'block');
      requestAnimationFrame(() => { $lightboxImg.css('opacity', '1'); });

      isLoadingImage = false;
    };

    const onTempImageError = function() {
      console.error("Lightbox: Image failed to load:", item.src);
      $imageContainer.removeClass('is-loading'); 
      $imageContainer.css({ 'width': '', 'height': '', 'flex': '' });
      $lightboxImg.attr('alt', 'Image failed to load').show(); 
      isLoadingImage = false;
    };

    const $tempImg = $('<img>');
    $tempImg.on('load', onTempImageLoad).on('error', onTempImageError);
    $tempImg.attr('src', item.src); 
  }

  function updateTextAndControls(item) {
      $lightboxTitle.text(item.title);
      $lightboxDescription.text(item.description);
      
      if (item.credit && item.credit.trim() !== '') {
          $lightboxCredit.text(item.credit);
          $lightboxCreditContainer.show();
      } else {
          $lightboxCredit.text('');
          $lightboxCreditContainer.hide();
      }
      
      if (galleryItems.length > 1) {
        $prevButton.removeClass('is-hidden');
        $nextButton.removeClass('is-hidden');
      } else {
        $prevButton.addClass('is-hidden');
        $nextButton.addClass('is-hidden');
      }

      if (item.element.closest('[id$="__gallery_ELQQRE"]').length > 0) {
        $lightboxModal.addClass('about-us-gallery-active');
        if (window.innerWidth > 767) {
          applyAboutUsRadius();
        }
      } else {
        $lightboxModal.removeClass('about-us-gallery-active');
        clearAboutUsRadius();
      }

      applyMaxTextContentHeight();
  }
  
  function closeLightbox() {
    $lightboxModal.removeClass('is-visible about-us-gallery-active').attr('aria-hidden', 'true');
    $lightboxImg.attr('src', '').stop(true,true).hide(); 
    $lightboxOverlay.css('display', 'none'); 
    
    $imageContainer.css({ 'width': '', 'height': '', 'flex': '' });
    clearAboutUsRadius();
    $card.css('width', '');
    $lightboxTextContent[0].style.removeProperty('height');

    if ($lastFocusedElement) { $lastFocusedElement.focus(); }
    enableBodyScroll();
    isLoadingImage = false; 
  }

  function showNextImage() {
    if (galleryItems.length === 0 || isLoadingImage) return;
    let nextIndex = currentIndex + 1;
    if (nextIndex >= galleryItems.length) nextIndex = 0; 
    openLightbox(nextIndex);
  }

  function showPrevImage() {
    if (galleryItems.length === 0 || isLoadingImage) return;
    let prevIndex = currentIndex - 1;
    if (prevIndex < 0) prevIndex = galleryItems.length - 1; 
    openLightbox(prevIndex);
  }

  function disableBodyScroll() { $('body').css('overflow', 'hidden'); }
  function enableBodyScroll()  { $('body').css('overflow', ''); }
  
  $(document).on('click', '.popup-gallery a', function(e) {
    e.preventDefault();
    initializeGalleryItems(); 
    $lastFocusedElement = $(this); 
    let clickedIndex = -1;
    for (let i = 0; i < galleryItems.length; i++) {
        if (galleryItems[i].element.is($(this))) { clickedIndex = i; break; }
    }
    if (clickedIndex !== -1) {
      openLightbox(clickedIndex);
    } else {
      console.warn("Lightbox: Clicked item not found.");
    }
  });

  $lightboxCloseButton.on('click', closeLightbox);
  $lightboxOverlay.on('click', closeLightbox); 
  $prevButton.on('click', showPrevImage);
  $nextButton.on('click', showNextImage);

  $(document).on('keydown', function(e) {
    if ($lightboxModal.hasClass('is-visible')) {
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight' && !$nextButton.hasClass('is-hidden')) {
        showNextImage();
        $nextButton.focus();
      }
      if (e.key === 'ArrowLeft' && !$prevButton.hasClass('is-hidden')) {
        showPrevImage();
        $prevButton.focus();
      }
      if (e.key === 'Tab') {
        const focusableElements = $lightboxModal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
        const firstFocusable = focusableElements.first();
        const lastFocusable  = focusableElements.last();
        if (e.shiftKey && document.activeElement === firstFocusable[0]) {
          lastFocusable.focus(); e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === lastFocusable[0]) {
          firstFocusable.focus(); e.preventDefault();
        }
      }
    }
  });

  initializeGalleryItems(); 
  $(document).on('shopify:section:load', function(event) {
    if ($(event.target).find('.popup-gallery').length > 0) initializeGalleryItems();
  });

  // ── Support page: whole-tile click ──────────────────────────────────
  document.querySelectorAll('.support-page .multicolumn-card').forEach(function(card) {
    var link = card.querySelector('.link.animate-arrow');
    if (!link) return;
    card.style.cursor = 'pointer';
    card.addEventListener('click', function(e) {
      if (!e.target.closest('a, button')) {
        if (link.target === '_blank') {
          window.open(link.href, '_blank', 'noopener');
        } else {
          window.location.href = link.href;
        }
      }
    });
  });

});
